import { VWOUserStorageConfig } from 'vwo-node-sdk'

const buildKey = <T extends { userId: string; campaignKey: string }>({
    userId,
    campaignKey,
}: T) => {
    return `vwo-user-storage-${userId}-${campaignKey}`
}

/**
 * User storage for VWO to store campaigns variations
 * Next time VWO's "activate" will take information from storage instead of requesting it from API
 */
export const vwoUserStorage: VWOUserStorageConfig = {
    get: (userId, campaignKey) => {
        return JSON.parse(
            localStorage.getItem(buildKey({ userId, campaignKey })) || '{}',
        )
    },
    set: campaignData => {
        localStorage.setItem(
            buildKey(campaignData as any),
            JSON.stringify(campaignData),
        )
    },
}
